export default __webpack_public_path__ + "static/peachNoteBoss-02a2c04cc9d5f952d583ef22cc6aa346.png";